import axios from 'axios';
import qs from 'qs';
import Storage from '../storage';
import SessionService from './SessionService';

// `data` is the data to be sent as the request body
// Only applicable for request methods 'PUT', 'POST', and 'PATCH'
export async function getHttpClient(
  path,
  method,
  data,
  params,
  headers,
) {
  const query =
    params !== null ? '?' + qs.stringify(params, {allowDots: true}) : '';
  const client = axios.create({
    baseURL: path + query,
    // url: path + query,
    method: method,
    timeout: 60 * 1000,
    headers: headers || {},
  });

  client.interceptors.request.use(
    function (config) {
      const token = Storage.token.getValue();
      if (token) {
        config.headers.Authorization = token;
      }

      if (headers !== null && headers !== undefined) {
        config.headers = {...config.headers, ...headers};
      }
      config.data = data;
      return config;
    },
    function (error) {
      return Promise.reject(error);
    },
  );

  // Add a response interceptor
  client.interceptors.response.use(
    async function (response) {
      return response;
    },
    async function (error) {
      let data = error.response || {};

      const status = error?.response?.status;
      const responseData = error?.response?.data;

      // Check if this is an onboarding gate failure (should not trigger a logout)
      const isOnboardingCode = ["PASSWORD_CHANGE_REQUIRED", "EMAIL_REGISTRATION_REQUIRED", "EMAIL_VERIFICATION_REQUIRED"].includes(responseData?.code);

      // Check if this is a login request (should not trigger a session expiration alert)
      const urlStr = error?.config?.url || error?.config?.baseURL || "";
      const isLoginRequest = urlStr.includes("/login");

      // Only logout on 401 (Unauthorized) or 403 without isLocked, and not onboarding code, and not a login request
      if (
        (status === 401 && !isLoginRequest) || 
        (status === 403 && !responseData?.isLocked && !isOnboardingCode)
      ) {
        SessionService.unAuthenticated()
      }
      
      if (data.hasOwnProperty('data')) {
        data = data.data;
      }
      return Promise.reject(data);
    },
  );
  return client.request();
}
